import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { RequestInformationPage } from './RequestInformationPage';
import { areaStudyLandings, getAreaStudyLanding } from '../data/areaStudyLandings';

// /areas-of-study/<area-slug>/<version> — an area-specific version of the
// streamlined v1 request-information flow. The area is fixed by the URL, so
// the first step asks for degree level and program instead.
export function AreaOfStudyLandingPage() {
  const params = useParams<{
    areaSlug?: string;
    version?: string;
  }>();
  const location = useLocation();
  // The preview's route list can render this page without params; fall back
  // to parsing the path, then to the first configured landing.
  const [,, pathArea, pathVersion] = location.pathname.split('/');
  const areaSlug = params.areaSlug || pathArea;
  const version = params.version || pathVersion;
  const landing = getAreaStudyLanding(areaSlug, version) || Object.values(areaStudyLandings)[0];
  return <RequestInformationPage variant={`area-${areaSlug}-${version}`} lockedAreaId={landing.areaId} content={landing.content} data-id="element-836" data-mp="x8pren6tdm74" />;
}